import { UserStatuses } from 'globals/constants'
import { useSelector } from 'react-redux'
import { AuthSliceSelector } from 'store/slices'
import { PaymentDeclinedUserBillingInfoCard } from './PaymentDeclinedUserBillingInfoCard'
import { PaidAccountOwnerBillingCard } from './PaidAccountOwnerBillingCard'

export const AccountOwnerBillingCard = () => {
  const { CurrentUser } = useSelector(AuthSliceSelector)

  return (
    <>
      {CurrentUser?.Status === UserStatuses.PAYMENT_DECLINED ? (
        <PaymentDeclinedUserBillingInfoCard />
      ) : (
        <PaidAccountOwnerBillingCard />
      )}
    </>
  )
}
